
import { Component, Watch } from 'vue-property-decorator';

import Booking from '@/views/Booking.vue';

import ActionsFilterCard from '@/components/activities/FilterCard.vue';

import { BookingsApi } from '@/api/BookingsApi';

import { HotelsApi } from '@/api/HotelsApi';

import { mapState } from 'vuex';

import { MetaInfo } from 'vue-meta';

import { first, mapValues, sortBy } from 'lodash';

import { findColor, findDate } from '@/config/functions';

@Component({
   computed: {
      ...mapState({
         acc_colors: (s: any) => s.activities.colors,
      }),
   },
   metaInfo(): MetaInfo {
      return {
         title: '',
         titleTemplate: 'Accommodation report',
      };
   },
   filters: {
      formatDate: (act_day: any) => (act_day != null ? new Date(act_day * 8.64e7).toISOString() : ''),
   },
   components: {
      ActionsFilterCard,
   },
})
export default class Activities extends Booking {
   accommodations: any[] = [];

   room_types: any[] = [];

   stripos!: any;

   addColorTooltips!: any;

   guides: any[] = [];

   transfers: any[] = [];

   suppliers: any[] = [];

   acc_colors!: any[];

   activities_colors!: any[];

   payment_colors!: any[];

   customFormatter!: any;

   formatterDate!: any;

   formatTime!: any;

   default_colors!: any;

   fields: any[] = [];

   allAccommodations: any[] = [];

   orders: any[] = [];

   filtered: any[] = [];

   dateRange: Date[] = [];

   seenAcc: boolean = false;

   shareAcc: string = '';

   filter: any = {
      ...this.default_colors,

      o_group_color: '#FEFEFE',

      acс_status: '#ffffff',
      moto_overal_status: '#ffffff',
      acс_payment_status: '#ffffff',

      moto_lead_guest: '',
      acс_number_rooms: '',
      acс_room_type_id: '',
      acс_checkin_date: '',
      acс_nts: '',
      acс_cost: '',
      acс_supp_name: '',
      moto_acс_form: '',
      accommodations: [],
   };

   created(): void {
      const $start = this.$moment(this.$localStorage.getItem('activities-list.startDate'));
      const $end = this.$moment(this.$localStorage.getItem('activities-list.endDate'));

      this.dateRange = [
         $start.isValid() ? $start.toDate() : this.$moment().toDate(),
         $end.isValid()
            ? $end.toDate()
            : this.$moment()
                 .add(30, 'd')
                 .toDate(),
      ];

      this.fields = [
         {
            key: 'acс_status',
            label: 'ACC STATUS',
            thAttr: {
               style: 'width: 100px;',
            },
         },
         {
            key: 'moto_overal_status',
            label: 'GROUP STATUS',
            thAttr: {
               style: 'width: 50px;',
            },
            thClass: 'text-center',
         },
         {
            key: 'o_group_color',
            label: 'group color',
            thAttr: {
               style: 'width: 43px;',
            },
         },
         {
            key: 'moto_lead_guest',
            sortable: true,
            label: 'Lead Guest',
            tdClass: 'text-center',
         },
         {
            key: 'moto_our_reference',
            sortable: true,
            label: 'OUR REF NR.',
            tdClass: 'text-center',
            thAttr: {
               style: 'width: 85px;',
            },
         },
         {
            key: 'acс_supp_name',
            sortable: true,
            label: 'Accommodation',
            tdClass: 'text-center',
         },
         {
            key: 'acс_number_rooms',
            sortable: true,
            label: 'Number of Rooms',
            tdClass: 'text-center',
         },
         {
            key: 'acс_room_type_id',
            sortable: true,
            label: 'Room Type',
            tdClass: 'text-center',
            formatter: (o_id: number) => first(this.room_types.filter(d => d.d_id == o_id))?.d_name,
         },
         {
            key: 'acс_checkin_date',
            sortable: true,
            label: 'Check-in Date',
            tdClass: 'text-center',
         },
         {
            key: 'acс_nts',
            sortable: true,
            label: 'Nights',
            tdClass: 'text-center',
         },
         {
            key: 'acс_cost',
            sortable: true,
            label: 'Cost €',
            tdClass: 'text-center',
            formatter: (value: string) => this.$options.filters?.toFixed2(value),
         },
         {
            key: 'moto_acс_form',
            label: 'ACCOMMODATION FORM',
            tdClass: 'text-center',
         },
         {
            key: 'acс_payment_status',
            sortable: false,
            label: 'payment status',
            thAttr: {
               style: 'width: 50px;',
            },
         },
      ];

      this.filter = {
         ...this.filter,
         ...mapValues(this.$route.query, (val: string) => {
            const value = val.split(';');
            return value.length == 1 ? first(value) : value;
         }),
      };
   }

   beforeDestroy(): void {
      this.$store.commit('showLoading');
   }

   shareAccommodation() {
      if (!this.dateRange[0] || !this.dateRange[1]) return;

      const id = this.shareAcc;
      const operationName = first(this.accommodations.filter((o: any) => o.o_uuid === id))?.o_name;
      const routeData = this.$router.resolve({
         name: 'accommodation.report',
         params: { id },
         query: {
            dateFrom: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
            dateTo: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
            operationName,
         },
      });

      window.open(routeData.href, '_blank');
   }

   filterData() {
      const filter = {
         acс_status: '#ffffff',
         moto_lead_guest: '',
         acс_number_rooms: '',
         acс_room_type_id: '',
         acс_checkin_date: '',
         acс_nts: '',
         acс_cost: '',
         moto_acс_form: '',
         acс_supp_name: '',
         accommodations: [],
         ...this.filter,
      };

      this.filtered = this.orders.filter(a => {
         const room_type = first(this.room_types.filter(g => g.d_id == a.acс_room_type_id));

         const filtered: any = {
            acс_payment_status: findColor(
               filter['acс_payment_status'],
               a.acс_payment_status,
               this.default_colors['acс_payment_status'],
               this.payment_colors
            ),

            accommodations: !filter.accommodations.length || filter.accommodations.includes(parseInt(a.acс_supp_id)),
            acс_room_type_id: filter.acс_room_type_id === '' || this.stripos(room_type?.d_name, filter.acс_room_type_id),

            acс_checkin_date: findDate(filter['acс_checkin_date'], a.acс_checkin_date),
         };

         for (const f of Object.keys(filter)) {
            if (!a[f] || Object.keys(filtered).includes(f)) continue;

            if (f.indexOf('_status') >= 0 || f.indexOf('_color') >= 0) {
               filtered[f] = !filter[f].length || findColor(filter[f], a[f], this.default_colors[f]);
               continue;
            }

            filtered[f] = filter[f] === '' || this.stripos(a[f], filter[f]);
         }

         return Object.keys(filtered).length == Object.values(filtered).filter(f => f).length;
      });
   }

   getColor(color: number) {
      return '#' + (first(this.acc_colors.filter(c => c.id == color))?.d_color_code ?? 'ffffff');
   }

   download(type: string) {
      const $body = this.downloadData();

      const $fields = this.fields.map((f: any) => ({
         header: f.label.toUpperCase(),
         key: f.key,
         hidden: false,
         width: ['moto_lead_guest'].includes(f.key) ? 32 : 12,
      }));

      // @ts-ignore
      this.__download(
         type,
         $fields,
         $body,
         [this.dateRange[0], this.dateRange[1]].map((r: any) => this.$moment(r).format(this.customFormatter.dateFormat)).join('-')
      );
   }

   downloadData() {
      const keys = this.fields.map((f: any) => f.key);
      const filtered = sortBy(this.filtered, 'acс_checkin_date');

      return filtered.map((item: any) => {
         const result: any[] = [];

         for (const key of keys) {
            let value = item[key] ? item[key] : '';
            let res: any = {};

            switch (key) {
               case 'acс_checkin_date':
                  value = this.$moment(item.acс_checkin_date).format(this.customFormatter.dateFormat);
                  res = { key, value };
                  break;

               case 'acс_status':
                  if (item.acс_status_name != '' && item.acс_status != '') {
                     value = item.acс_status_name;
                     res = { key, value, color: item.acс_status };
                  }
                  break;

               case 'acс_room_type_id':
                  value = first(this.room_types.filter(g => g.d_id == item.acс_room_type_id))?.d_name;
                  res = { key, value };
                  break;

               case 'acс_cost':
                  value = parseInt(item.acс_cost).toFixed(2);
                  res = { key, value };
                  break;

               default:
                  res = { key, value };
                  break;
            }

            result.push({ ...res, label: this.fields.filter(i => i.key == res.key)[0]['label'] });
         }

         return result;
      });
   }

   findOrders() {
      this.$store.commit('showLoading');

      let params = {
         dateFrom: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
         dateTo: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
      };

      if (!this.dateRange[0] || !this.dateRange[1]) return;
      this.$store.commit('setItems', { name: 'ready', value: false });
      Promise.all([
         this.$store.dispatch('activities/GET_DICTIONARIES'),
         HotelsApi.getAccommodationsDataByDate(params),
         HotelsApi.accommodationsData(),
      ])
         .then((data: any[]) => {
            this.orders = sortBy(data[1]['Accommodation by date'], 'acс_checkin_date');
            this.accommodations = sortBy(data[2]['Accommodation suppliers'], 'o_name');
            this.room_types = sortBy(data[2]['dic_room_type'], 'o_name');
         })
         .finally(() => {
            this.addColorTooltips(['.orders-list'], this.acc_colors);
            this.$store.commit('setItems', { name: 'ready', value: true });
            this.$store.commit('hideLoading');
         });
   }

   updateActivityValue(table: string, text: string, field: number, data: any) {
      const order = first(this.orders.filter((o: any) => o.id === data.item.id));
      const index = data.item.activity.index;

      order[table][index][field] = text;

      this.$store.commit('showLoading');

      // @ts-ignore
      BookingsApi.saveOrder(order.id, { o_id: order.id, [table]: order[table] }).then(result => {
         this.orders = this.orders.map((obj: any) => (obj.o_id === result.o_id ? result : obj));
      });
   }

   changePaymentStatus($event: any, data: any) {
      data.acс_payment_status = first(this.payment_colors.filter(a => a.d_color_code == $event))?.id;

      BookingsApi.changePaymentStatus(
         {
            group_id: data.moto_id,
            acс_id: data.acс_id,
            number_of_room: data.acс_number_rooms,
            room_type: data.acс_room_type_id,
            acс_checkin_date: this.formatterDate(data.acс_checkin_date),
            nights: this.formatTime(data.acс_nts),
            payment_status: data.acс_payment_status,
         },
         'accommodation'
      );
   }

   @Watch('$route', { immediate: false, deep: true })
   onRoute(n: any, o: any) {
      if (n.name !== o.name) {
         this.findOrders();
      }
   }

   @Watch('dateRange', { immediate: false, deep: true })
   onChangeDateRange(n: string[]) {
      if (n.length) {
         this.$localStorage.setItem('activities-list.startDate', n[0]);
         this.$localStorage.setItem('activities-list.endDate', n[1]);
         this.findOrders();
      }
   }

   @Watch('orders')
   changeOrders() {
      this.allAccommodations = [];

      this.filterData();
   }

   tbodyTrClass(row: any) {
      return [this.formatterDate(row.acс_checkin_date) == this.$moment().format('YYYY-MM-DD') ? 'today' : ''];
   }

   @Watch('filter', { immediate: true, deep: true })
   changeFilter(filter: any, old: any) {
      const query = mapValues({ ...this.$route.query, ...filter }, value => {
         return Array.isArray(value) ? value.join(';') : value;
      });

      if (query['acс_checkin_date'] != null) {
         query['acс_checkin_date'] = this.$moment(query['acс_checkin_date']).format();
      }

      if (query.accommodations !== undefined) {
         delete query.accommodations;
      }

      this.$router.push({ query }).catch(() => {});

      this.filterData();
   }
}
